import AppError from 'utils/appError';

const NETWORK_CODE_SET = new Set([
  // your app / custom
  'post_request_failed',
  'no_network_connectivity',

  // axios v1
  'err_network',

  // node-style codes (sometimes bubble up depending on environment)
  'econnreset',
  'econnrefused',
  'enotfound',
  'eai_again',
  'enetdown',
  'enetunreach',
  'ehostunreach',

  // timeouts (node often uses ETIMEDOUT; axios XHR uses ECONNABORTED for timeouts)
  'etimedout',
  'econnaborted',
]);

const NETWORK_TEXT_NEEDLES = [
  // fetch / browser / RN-ish messages
  'failed to fetch',
  'network request failed',
  'networkerror when attempting to fetch resource',
  'load failed',

  // axios common
  'network error',
  'err_network',
  'timeout',
  'etimedout',
  'econnreset',
  'econnrefused',
  'enotfound',
];

const ABORT_CODE_SET = new Set([
  // Axios v1
  'err_canceled',

  // Sometimes surfaced by libs / older axios / custom wrappers
  'cancelled',
  'canceled',
]);

const ABORT_TEXT_NEEDLES = [
  // Browser AbortController
  'aborterror',
  'the operation was aborted',

  // Generic
  'request aborted',
  'aborted',
  'canceled',
  'cancelled',
];

const normalize = (s?: unknown) => (typeof s === 'string' ? s.toLowerCase() : '');

const containsAny = (haystack: string, needles: string[]) => needles.some((n) => haystack.includes(n));

export const isNetworkError = (error: AppError | undefined): boolean => {
  if (!error) return false;

  const code = normalize(error.code);
  if (code && NETWORK_CODE_SET.has(code)) return true;

  const message = normalize(error.message);
  const debug = normalize(error.debug);

  // Check combined text once (avoids repeating `.includes` work)
  const combined = `${message} ${debug}`.trim();

  return combined.length > 0 && containsAny(combined, NETWORK_TEXT_NEEDLES);
};

export const isLoginError = (error: AppError | undefined): boolean => {
  if (!error) return false;

  const filterMsg: string[] = ['login_error'];

  const isLoginError = filterMsg.some((msg) => {
    if (error.code === msg) return true;

    return false;
  });

  return isLoginError;
};

export const isAbortOrCancelError = (error: AppError | undefined): boolean => {
  if (!error) return false;

  const code = normalize(error.code);
  if (code && ABORT_CODE_SET.has(code)) return true;

  // Combine once to minimize work
  const combined = `${normalize(error.message)} ${normalize(error.debug)}`.trim();

  return combined.length > 0 && containsAny(combined, ABORT_TEXT_NEEDLES);
};

export const isAuthReloadError = (error: AppError | undefined): boolean => {
  return (
    (error?.code === '403' &&
      (error?.debug?.startsWith('Path: /auth') ||
        error?.debug?.startsWith('Path: /tenant') ||
        error?.debug?.startsWith('Path: tenant') ||
        error?.debug?.startsWith('Path: iso'))) ??
    false
  );
};
